import type { en } from '../i18n/locales/en.js';

export type ChangelogEntry = {
  date: string;
  version: string;
  itemsKey: keyof typeof en.changelog.entries;
};

export const CHANGELOG: ChangelogEntry[] = [
  { date: '2026-10-01', version: '1.2.0', itemsKey: 'chessLaunch' },
  { date: '2026-09-30', version: '1.1.0', itemsKey: 'kozyolAndOnlineFixes' },
  { date: '2026-09-26', version: '1.0.0', itemsKey: 'publicLaunch' },
  { date: '2026-09-24', version: '0.25.0', itemsKey: 'invitesEverywhere' },
  { date: '2026-09-24', version: '0.24.1', itemsKey: 'inviteAndPresenceFixes' },
  { date: '2026-09-24', version: '0.24.0', itemsKey: 'realtimeOnCloudflare' },
  { date: '2026-09-23', version: '0.23.0', itemsKey: 'signedInPlayerSurfaces' },
  { date: '2026-09-23', version: '0.22.0', itemsKey: 'accountsAndIdentities' },
  { date: '2026-09-19', version: '0.21.3', itemsKey: 'roomCodesSixChar' },
  { date: '2026-09-18', version: '0.21.2', itemsKey: 'resumeParity' },
  { date: '2026-09-18', version: '0.21.1', itemsKey: 'onlineIdentityFixes' },
  { date: '2026-09-17', version: '0.21.0', itemsKey: 'serverHistorySync' },
  { date: '2026-09-16', version: '0.20.0', itemsKey: 'friendsAndInvites' },
  { date: '2026-09-12', version: '0.19.2', itemsKey: 'dominoConnectionOverlay' },
  { date: '2026-09-11', version: '0.19.1', itemsKey: 'onlineReconnectFix' },
  { date: '2026-09-10', version: '0.19.0', itemsKey: 'landingHeaderNav' },
  { date: '2026-09-09', version: '0.18.1', itemsKey: 'authPolishLegalPages' },
  { date: '2026-09-08', version: '0.18.0', itemsKey: 'identityInRooms' },
  { date: '2026-08-06', version: '0.17.0', itemsKey: 'mahjongLaunch' },
  { date: '2026-06-21', version: '0.16.0', itemsKey: 'optionalSignIn' },
  { date: '2026-06-11', version: '0.14.1', itemsKey: 'dominoLastAction' },
  { date: '2026-06-10', version: '0.14.0', itemsKey: 'afkPing' },
  { date: '2026-06-06', version: '0.13.0', itemsKey: 'sudokuLaunch' },
  { date: '2026-05-31', version: '0.10.1', itemsKey: 'dominoBoneyardPolish' },
  { date: '2026-05-28', version: '0.10.0', itemsKey: 'pwaInstall' },
  { date: '2026-05-27', version: '0.9.0', itemsKey: 'verifiableRng' },
  { date: '2026-05-27', version: '0.8.0', itemsKey: 'accessibilityPass' },
  { date: '2026-05-26', version: '0.7.0', itemsKey: 'inGameOverlay' },
  { date: '2026-05-26', version: '0.6.0', itemsKey: 'landingRefresh' },
  { date: '2026-05-25', version: '0.5.0', itemsKey: 'menuOverhaul' },
  { date: '2026-05-25', version: '0.4.1', itemsKey: 'backgammonOnlineFixes' },
  { date: '2026-05-24', version: '0.4.0', itemsKey: 'dominoLaunch' },
  { date: '2026-05-17', version: '0.3.0', itemsKey: 'monorepoMigration' },
  { date: '2026-05-17', version: '0.2.0', itemsKey: 'checkersLaunch' },
  { date: '2026-04-15', version: '0.1.0', itemsKey: 'backgammonLaunch' },
];
